<template>
    <div class="step-trial-class">
        <v-row>
            <v-col cols="12" md="6">
                <v-menu 
                    v-model="trialDateMenu" 
                    :close-on-content-click="false" 
                    :nudge-right="40" 
                    transition="scale-transition" 
                    offset-y 
                    min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field 
                            outlined 
                            :value="trialDate" 
                            label="Trial Date" 
                            placeholder="Trial date" 
                            prepend-inner-icon="mdi-calendar" 
                            readonly 
                            hide-details 
                            v-bind="attrs" 
                            v-on="on"
                        />
                    </template>
                    <v-date-picker 
                        :min="minTrialDate" 
                        :value="trialDate" 
                        @input="onTrialDateChange" 
                        color="primary"
                    />
                </v-menu>
            </v-col>
            <v-col cols="12" md="6">
                <time-input 
                    :value="trialTime" 
                    @input="$emit('update:trialTime', $event)"
                    :dense="mobile" 
                    :hide-icon="mobile" 
                    half-format 
                    outlined 
                    label="Trial Class Time" 
                    placeholder="Trial Class Time" 
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>
import TimeInput from '@/components/custom/time-input';

export default {
    name: 'WizardStepTrialClass',
    components: {
        TimeInput
    },
    props: {
        trialDate: {
            type: String,
            default: ''
        },
        trialTime: {
            type: String,
            default: ''
        },
        minTrialDate: {
            type: String,
            required: true
        },
        mobile: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            trialDateMenu: false
        };
    },
    methods: {
        onTrialDateChange(date) {
            this.$emit('update:trialDate', date);
            this.trialDateMenu = false;
        }
    }
};
</script>

<style lang="scss" scoped>
</style>

